<script lang="ts">
</script>
<div class="header bg-light">
    <ul >
        <li></li>
        <li></li>
        <li></li>
    </ul>
</div>    